import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d1392c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "list-container"
}
const _hoisted_2 = { key: 0 }

import ListItemsSelect from "@/components/select/ListItemsSelect/ListItemsSelect.vue";
import { GetterTypes } from "@/store";
import { computed } from "vue";
import { IListItem } from "@/types/list";
import { useComputedValue } from "@/composables/useComputedValue";

interface Props {
  listItemsArray: IListItem[];
  title?: string;
}

interface ListItemsSelectEmits {
  (e: "add-member", member: IListItem): void;
  (e: "remove-member", member: IListItem): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewChatListContainer',
  props: {
    listItemsArray: {},
    title: {}
  },
  emits: ["add-member", "remove-member"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;
const filter = useComputedValue<string>(GetterTypes.GET_CHATS_FILTER);
const filteredArray = computed(() => {
  return props.listItemsArray.filter((item) =>
    item.text.toLowerCase().includes(filter.value.toLowerCase().trim()),
  );
});
const isListShown = computed(() => {
  return !!filteredArray.value.length;
});

const addMember = (item: IListItem) => {
  emit("add-member", item);
};
const removeMember = (item: IListItem) => {
  emit("remove-member", item);
};

return (_ctx: any,_cache: any) => {
  return (isListShown.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_2, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true),
        _createVNode(ListItemsSelect, {
          "list-items-array": filteredArray.value,
          onAddMember: addMember,
          onRemoveMember: removeMember
        }, null, 8, ["list-items-array"])
      ]))
    : _createCommentVNode("", true)
}
}

})